import React, { useEffect } from 'react'
import Layout from './Layout';
import { useDispatch, useSelector } from 'react-redux';
import { get, useForm } from 'react-hook-form';
import { nextStep, setFormData } from '../../redux/slice/findJobSlice';
import { handleUploadFile } from '../../redux/action/commonAction';
import Button from '../../components/general/Button';
import Input from '../../components/general/Input';
import { yupResolver } from '@hookform/resolvers/yup';
import { stepSixValidationSchema } from '../../utils/validation';
import { getShrunkText } from '../../utils';

const StepSixForm = () => {
    const dispatch = useDispatch();
    const { cv_id, ...rest } = useSelector(state => state.findJob.stepSixData);
    const { watch, setValue, register, getValues, handleSubmit, setError, formState: { errors } } = useForm({
        mode: "all",
        defaultValues: rest,
        resolver: yupResolver(stepSixValidationSchema)
    });

    const file = watch("updated_cv");

    useEffect(() => {
        if (file) {
            const formdata = new FormData();
            formdata.append("file", file);
            dispatch(handleUploadFile(formdata)).then(({ status, data }) => {
                if (status === 201) dispatch(setFormData({ formData: { cv_id: data.id } }));
            })
        }
        // eslint-disable-next-line
    }, [file]);

    const onFileChange = (e) => {
        const file = e.target?.files[0];
        if (!file) return;
        setValue("updated_cv", file)
        e.target.value = ""
    }

    const handleFormSubmit = () => {
        // Manually set error if no link_to_cv and updated_cv
        const { linkedin_url, link_to_cv, updated_cv } = getValues();

        if(!linkedin_url) {
            setError("linkedin_url", { message: "LinkedIn URL is required" });
        }

        if(!link_to_cv && !updated_cv) {
            setError("link_to_cv", { message: "Either LinkedIn URL or CV URL is required" });
            return;
        }

        handleSubmit((data) => {
            dispatch(setFormData({ formData: data }));
            dispatch(nextStep())
        })()
    }

    return (
        <div className='min-h-[60vh] !py-[50px] !pb-[50px] lg:flex lg:justify-between'>
            <div className=''>
                <div>
                    <p className='text-primary-color'> 6/8 </p>
                    <h1 className="text-[1.6rem] font-semibold">
                        <span> Add your experience </span>
                        {/* <Image src={DoubleStar} alt="double-star" className="hidden lg:inline-block" /> */}
                        <span className='lg:block'> Highlights </span>
                    </h1>
                </div>

                <div className='hidden lg:block mt-[20px] text-[#2A2A2A]'>
                    <div className='mt-[20px]'>
                        <p> 7/8 </p>
                        <h1 className="text-[1.6rem] font-semibold">
                            <span> Ready to pass an </span>
                            <span className='lg:block'> interview in English? </span>
                        </h1>
                    </div>
                    <div className='mt-[20px]'>
                        <p> 8/8 </p>
                        <h1 className="text-[1.6rem] font-semibold">
                            <span> Submit your application to </span>
                            <span className='lg:block'> Devhire </span>
                        </h1>
                    </div>
                </div>
            </div>

            <div className='lg:w-[55%]'>
                <div className='hidden lg:flex gap-[20px] text-[13px] mb-[40px] lg:justify-center'>
                    <p className='text-primary-color'> 1. Project Preferences </p>
                    <p className='text-primary-color'> 2. Specialization in stack </p>
                    <p className='text-primary-color'> 3. Additional info </p>
                    <p> 4. Registration </p>
                </div>

                <div className='text-[15px] mb-[30px]'>
                    <div className='flex items-center lg:justify-center gap-[10px] text-[#797979] mt-[20px]'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 hidden lg:block">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>

                        <div className='text-left lg:text-center'>
                            Add cv or linkedin so we could know you better (at least on is required)
                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-4 mt-[20px] w-full'>
                    <Input 
                        name="linkedin_url" 
                        register={register} 
                        placeholder='LinkedIn URL' 
                        type="text" 
                        className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[50px]' 
                        error={errors.linkedin_url?.message}
                    />

                    <div className='lg:flex justify-between items-center'>
                        <div className='w-[70%]'>
                            <Input 
                                name="link_to_cv" 
                                register={register} 
                                placeholder='Link to CV' 
                                type="text" 
                                className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[50px]' 
                                error={errors.link_to_cv?.message || errors.cv_id?.message}
                            />
                        </div>
                        <p className='text-center text-[14px] py-[10px] lg:py-0'>Or</p>
                        <label htmlFor="cv" className='text-center flex items-center justify-center gap-[10px] bg-black h-[40px] rounded cursor-pointer lg:w-[20%]'> 
                            Updated CV 
                        </label>
                        <input name='cv_id' disabled={Boolean(watch("updated_cv"))} className='hidden' type="file" onChange={onFileChange} id="cv" />
                    </div> 
                    {
                        file?.name && <div>
                            <p className='font-extralight mb-[10px] lg:-translate-y-[20px] lg:text-right'>{getShrunkText(file?.name)} <span onClick={() => {
                                setValue("updated_cv", null)
                                dispatch(setFormData({ formData: { cv_id: null } }));
                            }}>
                                <i className='fa fa-trash font-extralight ml-[10px] cursor-pointer' />
                            </span>
                            </p>
                        </div>
                    }
                </div>
                <Button 
                onClick={handleFormSubmit} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[18px] lg:text-[20px] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]' disabled={!Boolean(watch("total_experience"))}>Ok, next <i className="fa-solid fa-arrow-up-right" /></Button>
            </div>
        </div>
    )
}

export default StepSixForm;
